<script>

export default {
  name: 'PayApplicationFeeAuthForm',
  props: {
    data: {
      type: String,
      default: ""
    },
  },
  data () {
    return {
      dialog: false,
    }
  },
  computed: {

    status: {
      get() {
        return this.$store.state.program.payDialogStatus
      },
      set(value) {
        if (!value) {
          this.$store.commit('program/updatePayModalStatus')
        }
      }
    },
    temp(){
      return this.$store.state.program.payFormData
    }
  },
  watch: {
    status(newValue) {
      if (newValue && this.temp) {
        this.$nextTick(() => {
          this.loadIframe()
        })
      }
    },

    temp(newValue) {
      if (this.status && newValue) {
        this.$nextTick(() => {
          this.loadIframe()
        })
      }
    }
  },
  methods: {
    cancel(){
      this.$store.commit('program/updatePayModalStatus')
    },
    loadIframe() {
      const win = window.open('', '_blank')

      if (!win) {
        alert('Popup blocked. Please allow popups.')
        return
      }

      win.document.open()
      win.document.write(this.temp)
      win.document.close()
    }
  }

}
</script>

<template>
  <div class="text-center">
    <v-dialog
        v-model="status"
        width="500"
    >


      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Privacy Policy
        </v-card-title>

        <v-card-text>
          <iframe
              ref="paymentFrame"
              style="width:100%; height:600px; border:none;"
          ></iframe>
<!--          <div class="" v-html="temp"></div>
          <div>
            {{ temp }}
          </div>-->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="cancel"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>

</style>